


document.addEventListener("DOMContentLoaded", function () {
    // Tabs functionality
    document.querySelectorAll('ul.tabs').forEach(function (tabContainer) {
        const links = tabContainer.querySelectorAll('a');
        let active = links[0];
        let content = document.querySelector(active.getAttribute('href'));

        active.classList.add('active');

        links.forEach(function (link, index) {
            if (index !== 0) {
                const contentEl = document.querySelector(link.getAttribute('href'));
                if (contentEl) contentEl.style.display = 'none';
            }

            link.addEventListener('click', function (e) {
                e.preventDefault();
                active.classList.remove('active');
                content.style.display = 'none';

                active = link;
                content = document.querySelector(link.getAttribute('href'));
                active.classList.add('active');
                if (content) content.style.display = '';
            });
        });
    });

    // Wait for .slick-sliders-desk
    let deskInterval = setInterval(function () {
        const el = document.querySelector("body.index .slick-sliders-desk");
        if (el && typeof jQuery !== "undefined" && typeof jQuery(el).slick === "function") {
            clearInterval(deskInterval);
            jQuery(".slick-sliders-desk").slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0936/7014/6387/files/icons8-go-back-50.webp?v=1738308704'>",
                nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0936/7014/6387/files/icons8-circled-right-50.webp?v=1738308705'>",
                responsive: [
                    { breakpoint: 1280, settings: { slidesToShow: 4, slidesToScroll: 1 } },
                    { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } }
                ]
            });
        }
    }, 200);

    // Wait for .insgallery_isz
    let galleryInterval = setInterval(function () {
        const el = document.querySelector("body.index .insgallery_isz");
        if (el && typeof jQuery !== "undefined" && typeof jQuery(el).slick === "function") {
            clearInterval(galleryInterval);
            jQuery(".insgallery_isz").slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 6,
                slidesToScroll: 1,
                arrows: false,
                responsive: [
                    { breakpoint: 1280, settings: { slidesToShow: 6, slidesToScroll: 1 } },
                    { breakpoint: 768, settings: { slidesToShow: 5, slidesToScroll: 1 } },
                    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } }
                ]
            });
        }
    }, 200);

    // Wait for .slick-sliders-related
    let relatedInterval = setInterval(function () {
        const el = document.querySelector("body.product .slick-sliders-related");
        if (el && typeof jQuery !== "undefined" && typeof jQuery(el).slick === "function") {
            clearInterval(relatedInterval);
            jQuery(".slick-sliders-related").slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0936/7014/6387/files/icons8-go-back-50.webp?v=1738308704'>",
                nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0936/7014/6387/files/icons8-circled-right-50.webp?v=1738308705'>",
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: false } },
                    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1 } }
                ]
            });
        }
    }, 200);
});



document.addEventListener("DOMContentLoaded", function() {
  var items = document.querySelectorAll('.shopify-section.section:has(.jdgm-widget.jdgm-carousel) .jdgm-carousel-item');

  if (items.length > 0) {
    items.forEach(function(item) {

      
      var productImage = item.querySelector('.jdgm-carousel-item__product-image');
      var reviewContent = item.querySelector('.jdgm-carousel-item__review-content');
      var reviewerName = item.querySelector('.jdgm-carousel-item__reviewer-name'); 
        var reviewerTime = item.querySelector('.jdgm-carousel-item__timestamp ');
      
      
      if (productImage) {
        // Create the new wrapper div
        var wrapper = document.createElement('div');
        wrapper.className = 'newborder';

        // Move the productImage inside the new wrapper
        productImage.parentNode.insertBefore(wrapper, productImage);
        wrapper.appendChild(productImage);
      }



      if (reviewContent) {
        // Create a new div with class "timename"
        var timenameDiv = document.createElement('div');
        timenameDiv.className = 'timename';

        // Move the review content inside the new div
        reviewContent.appendChild(timenameDiv);
         if (reviewerName) {
          timenameDiv.appendChild(reviewerName);
        }
        if (reviewerTime) {
          timenameDiv.appendChild(reviewerTime);
        }
      }

      
    });
  }

    
  
});




document.addEventListener("DOMContentLoaded", function() {
    document.querySelector(".search__button.field__button").addEventListener("click", function(event) {
        var searchInput = document.querySelector(".search__input.field__input-s");
        if (searchInput.value.trim() === "") {
            searchInput.style.border = "1px solid red"; // Highlight input with red border
            event.preventDefault(); // Prevent form submission or unwanted action
        } else {
            searchInput.style.border = ""; // Remove border if input is filled
        }
    });
});


$(document).ready(function () {
  const disclaimer = `<div class="cart-disclaimer" style="margin-top: 20px; font-size: 14px; color: #555;">
      <p><strong>Note:</strong> Orders are processed within 3–5 business days.</p>
    </div>`;

  // Inject below cart form
  $('.cart__footer, .cart__submit-controls').before(disclaimer);
});


